export default __webpack_public_path__ + "static/media/MarketingExpand.894a993c.svg";